import shortUuid from 'short-uuid';

export function getShortUuid(uuid: string): string {
  return shortUuid().fromUUID(uuid);
}

export function getUuidFromShortUuid(short_uuid: string): string {
  return shortUuid().toUUID(short_uuid);
}
